var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.64 42.2H71.48c-.06 0-.1-.04-.1-.09V12.22c0-2.16-1.3-4.24-3.51-5.17-2.49-1.05-5.33-.55-7.16 1.06L2.07 59.62c-2.76 2.42-2.76 6.35 0 8.77l58.52 51.41c.95.83 2.14 1.45 3.47 1.63 3.99.56 7.32-2.12 7.32-5.42V85.89c0-.05.05-.09.1-.09h50.17c3.51 0 6.36-2.5 6.36-5.58V47.78c-.01-3.08-2.86-5.58-6.37-5.58z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.df2270d6.svg";
export { ForwardRef as ReactComponent };